// @flow
import React, { useEffect, useState } from "react";
import { connect } from "../../../base/redux";
import Tooltip from '@atlaskit/tooltip';

const CustomTooltip = (props) => {
    const { content, position, children, className="" } = props;

    useEffect(() => {
    }, []);

    const [showTitle, setShowTitle] = useState();

    const handleMouseOver = () => {
        setShowTitle(true)
    }

    const handleMouseLeave = () => {
        setShowTitle(false)
    }

    return (
        <div
            content={content}
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseLeave}
        >
            {showTitle && <span className={`${position==="bottom" ? 'custom-tooltip-bottom' : 'custom-tooltip'} ${className}`}>{content}</span>}
            {/* {<span className="custom-tooltip">{content}</span>} */}
            {children}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps)(CustomTooltip);

